(function () {
  const portals = [];
  const registered = new Map();
  
  const updatePortals = () => {    
    for (const portal of portals) {
      const isMatch = window.matchMedia(portal.getAttribute('hc-match')).matches;
      const content = registered.get(portal.getAttribute('hc-portal'));
      if (!content) {
        console.warn(`Portal content: "${portal.getAttribute('hc-portal')}" is not registered in ${registered.keys()}`);
        continue;
      }
      if (isMatch) {
        portal.after(content);
      } else {
        if (content.previousElementSibling == portal) content.remove();
      }
    }
  };
  
  const initPortals = () => {
    for(const el of Array.from(document.querySelectorAll('[hc-portal-content]'))) {
      registered.set(el.getAttribute('hc-portal-content'), el);
    };
    
    document.querySelectorAll('[hc-portal]').forEach(el => {
      portals.push(el);
    });
    
    updatePortals();
  };
  
  window.addEventListener('DOMContentLoaded', e => initPortals());
  window.addEventListener('resize', e => updatePortals());
})();